export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-960-cdd6037927fcb503d547ab4eee0f3cab.png";